import { apiInstance } from '@/api/instance';

export const signedApi = {
  logout: () => apiInstance.post('signed/logout'),
};
